import type { TrayWalls } from "./types";

/**
 * The two sides of the channel, offset perpendicular to the run.
 *
 * Drawn as two lines rather than one wide stroke with a lighter one over it:
 * that trick paints a filled band, and a filled band HIDES the architect's own
 * drawn tray — which is exactly what he is checking ours against.
 */
export const trayWalls: TrayWalls = ({ from, to, halfWidth }) => {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const length = Math.hypot(dx, dy);
  // A zero-length segment has no direction to offset along, and normalising it
  // would divide by zero and put NaN in the path.
  if (length === 0) return [];
  const px = (-dy / length) * halfWidth;
  const py = (dx / length) * halfWidth;
  return [
    {
      from: { x: from.x + px, y: from.y + py },
      to: { x: to.x + px, y: to.y + py },
    },
    {
      from: { x: from.x - px, y: from.y - py },
      to: { x: to.x - px, y: to.y - py },
    },
  ];
};
